import React, { useState, useEffect } from 'react'
import styles from './MutedNotification.module.scss'
import useCalculateInputVolume from '../../lib/useCalculateInputVolume'
import Notification from '../Notifications/Notification'
import classnames from 'classnames'
import { createLocalAudioTrack, LocalAudioTrack } from 'twilio-video'


const MutedNotification = ({selectedAudioDeviceId, isLocalParticipantMuted, hidden}) => {

  const [ isTheVolumeExceeded, setIsTheVolumeExceeded ] = useState(false)
  const [ timeoutRunning, setTimeoutRunning ] = useState(false)
  const [audioTrack, setAudioTrack] = useState<LocalAudioTrack | null>(null)
  const { currentVolume } = useCalculateInputVolume(audioTrack, isLocalParticipantMuted)

  useEffect( () => {

    function cleanup() {
      if (audioTrack) {
        audioTrack.disable()
        audioTrack.stop()
        audioTrack.detach()
      }
    }

    (async () => {
      if (!audioTrack || audioTrack.mediaStreamTrack.getConstraints().deviceId !== selectedAudioDeviceId) {
        cleanup()
        const audioTrackLocal = await createLocalAudioTrack({ deviceId: selectedAudioDeviceId })
        setAudioTrack(audioTrackLocal)
      }
    })()

    return cleanup
    
  }, [selectedAudioDeviceId, audioTrack])

  useEffect(() => {

    if (isLocalParticipantMuted && !hidden && currentVolume > 80 && !timeoutRunning) {

      setIsTheVolumeExceeded(true)
      setTimeoutRunning(true)

      // Reset states after 5 seconds to show the notification again if needed
      setTimeout(() => {

        setIsTheVolumeExceeded(false)
        setTimeoutRunning(false)

      }, 5000)

    }

  }, [ currentVolume, isTheVolumeExceeded, timeoutRunning, isLocalParticipantMuted, hidden ])

  return (
    <div
      data-bdd='muted-notification'
      className={classnames(
      styles['speaking-when-muted-notification'],
      {[styles['speaking-when-muted-notification--visible']]: isTheVolumeExceeded}
    )}>
      { isTheVolumeExceeded && <Notification text={'Trying to speak? You are currently muted'} /> }
    </div>
  )

}
export default MutedNotification